import {
  sharedContactError,
  sharedContactUserError,
} from 'src/redux/actions/contacts'
import { resetAppMessage, setAppMessage } from 'src/redux/actions/messages'
import Action from 'src/redux/action'

const DEFAULT_TIMEOUT = 5000

type Message = {
  text?: any
  type?: any
  timeout: number
}

const Message = (
  text: any,
  type = 'error',
  timeout = DEFAULT_TIMEOUT,
): Message => ({
  text,
  type,
  timeout,
})

type State = {
  message: Message
}

const initialState: State = {
  message: {
    text: null,
    type: null,
    timeout: DEFAULT_TIMEOUT,
  },
}

const messageReducer = (message: Message, action: Action): Message => {
  switch (action.type) {
    case sharedContactError.type:
      return Message(`Error: Contact ${action.contact} could not be shared`)
    case sharedContactUserError.type:
      return Message(`Error: Username ${action.username} not found`)
    default:
      return message
  }
}

export default (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case setAppMessage.type:
      return {
        ...state,
        message: {
          text: action.text,
          type: action.type,
          timeout: action.timeout || DEFAULT_TIMEOUT,
        },
      }
    case resetAppMessage.type:
      return initialState
    default:
      return {
        ...state,
        message: messageReducer(state.message, action),
      }
  }
}
